module.exports = __webpack_public_path__ + "static/media/we-commit-to.eb93f190.png";